import { Pipe, PipeTransform } from '@angular/core';

import {
  PricingLevelInterface,
  PricingOverrideInterface,
  PricingTierInterface,
} from './../../../../modules/pricing/interfaces/pricing.interface';

@Pipe({
  name: 'pricingHasOverride',
})
export class PricingHasOverridePipe implements PipeTransform {
  transform(
    tier :PricingTierInterface,
    level :PricingLevelInterface,
    overrides :PricingOverrideInterface[],
  ) :boolean {
    if (overrides?.length) {
      const matchedTier = overrides.find(
        (override) =>
          override.priceScheduleTierId === tier.id &&
          level.id === override.priceLevelId,
      );

      return matchedTier ? true : false;
    }

    return false;
  }
}
